// Format dates for display (DD-MM-YYYY)
export const formatDateForDisplay = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr + 'T00:00:00Z');
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

// Convert DD-MM-YYYY to YYYY-MM-DD for backend
export const formatDateForBackend = (ddmmyyyy) => {
  if (!ddmmyyyy) return '';
  const parts = ddmmyyyy.split('-');
  if (parts.length !== 3) return ddmmyyyy; // Return as-is if not in expected format
  const [day, month, year] = parts;
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

// Convert YYYY-MM-DD to DD-MM-YYYY for display
export const formatBackendDateForDisplay = (yyyymmdd) => {
  if (!yyyymmdd) return '';
  const parts = yyyymmdd.split('-');
  if (parts.length !== 3) return yyyymmdd; // Return as-is if not in expected format
  const [year, month, day] = parts;
  return `${day}-${month}-${year}`;
};

export const formatDateRange = (start, end) => {
  if (start === end) return formatBackendDateForDisplay(start);
  const opts = { month: 'short', day: 'numeric', year: 'numeric' };
  const s = new Date(start + 'T00:00:00Z');
  const e = new Date(end + 'T00:00:00Z');
  return `${s.toLocaleDateString(undefined, opts)} - ${e.toLocaleDateString(undefined, opts)}`;
};

// Number of nights between two YYYY-MM-DD dates (minimum 1).
export const getNights = (start, end) => {
  if (!start || !end) return 1;
  const s = new Date(start + 'T00:00:00Z');
  const e = new Date(end + 'T00:00:00Z');
  return Math.max(1, Math.round((e - s) / 86400000));
};

export const addOneDay = (dateStr) => {
  const d = new Date(dateStr + 'T00:00:00Z');
  d.setDate(d.getDate() + 1);
  return d.toISOString().split('T')[0];
};

export const getMinDate = (daysFromNow = 7) => {
  const minDate = new Date();
  minDate.setDate(minDate.getDate() + daysFromNow);
  return minDate.toISOString().split('T')[0];
};

export const getTodayDate = () => {
  return new Date().toISOString().split('T')[0];
};
